import { forwardRef, type SVGProps } from 'react'

type BboxTuple = readonly [number, number, number, number]

// SVGProps carries a legacy `bbox` presentation attribute, so drop it (and the geometry we
// derive) from the base and take our tuple instead.
type BboxProps = Omit<
  SVGProps<SVGRectElement>,
  'x' | 'y' | 'width' | 'height' | 'bbox'
> & {
  bbox: BboxTuple
}

// An SVG rect drawn from a [x1, y1, x2, y2] bbox: it owns the x/y/width/height math so the
// documents viewer and the screener draw overlays the same way. Everything else -- className,
// stroke, ref, mouse handlers -- passes straight through to the rect.
export const Bbox = forwardRef<SVGRectElement, BboxProps>(
  ({ bbox, ...rest }, ref) => {
    const [x1, y1, x2, y2] = bbox
    return (
      <rect
        ref={ref}
        x={x1}
        y={y1}
        width={x2 - x1}
        height={y2 - y1}
        {...rest}
      />
    )
  },
)
Bbox.displayName = 'Bbox'
